var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"armAlert"},[_c('b-alert',{attrs:{"variant":_vm.variant,"show":_vm.show}},[(_vm.html)?[_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})]:[_vm._v(" "+_vm._s(_vm.message)+" ")]],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }